import { View } from 'react-native'

import { styled } from '~/utils'

export const Footer = styled(View, theme => {
  return {
    base: {
      backgroundColor: theme.colorContainerFillDefault,
      borderColor: theme.colorContainerBorderDefault,
      borderBottomWidth: theme.borderWidthQuarterpulse,
      borderTopWidth: theme.borderWidthNone,
      borderLeftWidth: theme.borderWidthQuarterpulse,
      borderRightWidth: theme.borderWidthQuarterpulse,
      borderBottomLeftRadius: theme.borderRadiusMediumcontainer,
      borderBottomRightRadius: theme.borderRadiusMediumcontainer,
      borderTopLeftRadius: theme.borderRadiusNone,
      borderTopRightRadius: theme.borderRadiusNone,
    },
    variants: {},
  }
})

export const FooterContainer = styled(View, theme => {
  return {
    base: {
      maxWidth: 360,
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: 'center',
      width: '100%',
      paddingTop: theme.paddingInsetFourpulse,
      paddingBottom: theme.paddingInsetFourpulse,
      paddingLeft: theme.paddingInsetFourpulse,
      paddingRight: theme.paddingInsetFourpulse,
      gap: theme.paddingInsetFourpulse,
      backgroundColor: 'transparent',
    },
    variants: {},
  }
})
